// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerContent = "footer-module--footer-content--CL5AO";
export var firstRowSpacer = "footer-module--firstRowSpacer--s5Yvp";
export var siteLinks = "footer-module--site-links--TySmh";
export var brand = "footer-module--brand--3odJu";
export var social = "footer-module--social--kS8cm";
export var socialLink = "footer-module--social-link--OhXEC";
export var address = "footer-module--address--GvaNd";
export var copyright = "footer-module--copyright--NzlVR";